'use client';

import { AllOrganizationMembersAndPermissions } from '@trucksmarter/shared';
import { createContext, PropsWithChildren, useContext } from 'react';

const OrganizationMembersAndPermissionContext =
  createContext<AllOrganizationMembersAndPermissions | null>(null);

export function useOrganizationMembersAndPermissions() {
  const organizationMembersAndPermissions = useContext(
    OrganizationMembersAndPermissionContext,
  );

  return organizationMembersAndPermissions;
}

interface Props {
  value: AllOrganizationMembersAndPermissions | null;
}

export default function OrganizationMembersAndPermissionsProvider({
  value,
  children,
}: PropsWithChildren<Props>) {
  return (
    <OrganizationMembersAndPermissionContext.Provider value={value}>
      {children}
    </OrganizationMembersAndPermissionContext.Provider>
  );
}
